/**
 * Character limit shared by the note composer and note templates. The API
 * enforces the same ceiling on templates (`NOTE_TEMPLATE_CONTENT_MAX_LENGTH`),
 * so a template can never be longer than the note it is pasted into.
 */
export const NOTE_MAX_LENGTH = 1000

/**
 * Page ceiling for the note composer picker, which loads one page and filters
 * client-side (same approach and limit as the SMS picker).
 */
export const NOTE_TEMPLATE_PAGE_LIMIT = 200
